/**
 * @file tipIdempotency.js
 * @description 打赏预下单幂等键生成
 * @module features/comic/utils/tipIdempotency
 */

/**
 * 生成打赏幂等键（建议 UUID）
 * @returns {string}
 */
export function createTipIdempotencyKey() {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID()
  }
  return `tip-${Date.now()}-${Math.random().toString(36).slice(2, 12)}`
}
